<template>
    <div
        class="not-found h-full flex items-center justify-center flex-col"
        data-test="not-found-page"
    >
        <img
            class="not-found__image"
            src="../assets/images/error/notFound.png"
            :alt="t('error.not_found.image_alt')"
        >
        <div class="not-found__wrapper flex flex-col px-4 pb-4 sm:px-6 sm:pb-6 pt-2 md:pt-4 items-center justify-center">
            <h1 class="my-2 text-2xl sm:text-3xl md:text-5xl text-center">
                {{ t('error.not_found.title') }}
            </h1>
            <p class="text-base text-center">
                {{ t('error.not_found.description') }}
            </p>
            <button
                data-test="not-found-page-back-button"
                class="not-found__wrapper__back-button btn mt-6 sm:mt-8 text-center"
                @click="onBackButtonClick"
            >
                {{ t('error.not_found.action') }}
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useAccountStore } from '~/stores/accountStore';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();
    const event = useRequestEvent();
    if (event) setResponseStatus(event, 404);

    const onBackButtonClick = () => navigateTo('/', { replace: true });

    const { buttonColor, buttonTextColor } = useAccountStore().state;
</script>

<style lang="scss" scoped>
  .not-found {
    &__wrapper {
      &__back-button {
        border-color: v-bind(buttonColor);
        background-color: transparent;
        color: v-bind(buttonColor);
        padding: 1rem 2rem;

        &:hover {
          background-color: v-bind(buttonColor);
          color: v-bind(buttonTextColor);
        }
      }
    }

    &__image {
      width: 100%;
      min-height: 170px;
      object-fit: cover;
    }

    @media (max-width: theme('screens.sm')) {
      &__wrapper {
        &__back-button {
          padding: 0.8rem 1.4rem;
        }
      }
    }

    @media (min-width: theme('screens.sm')) {
      &__image {
        width: auto;
      }
    }
  }
</style>
